import api from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(lookup_key) {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key,
      origin_url: window.location.origin,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  } catch (e) {
    toast.error("Could not start checkout. Please try again.");
  }
}
